export class Note{
    noteText:string = '';
    changeBy:string = '';
    changeDate:Date = new Date();
}